<template>
  <div>
    <vuetable ref="vuetable"
            :api-mode="false"
            :fields="fields"
            pagination-path="pagination"
            @vuetable:load-error="handleLoadError"
            @vuetable:pagination-data="onPaginationData"
            :css="mycss.table"
            :perPage="perPage"
            data-path="records"
            :sort-order="sortOrder"
            @vuetable:row-clicked="onRowCLicked"
            :row-class="rowClass"
      >
       <template slot="details" slot-scope="props">
          <div class="table-button-container text-right text-nowrap">
            <button class="btn btn-info btn-sm" @click="detailsRow(props.rowData)">
              <i class="fa fa-search-plus"></i>
            </button>
            &nbsp;
          </div>
        </template>
        <template slot="details_and_history" slot-scope="props">
          <div class="table-button-container text-right text-nowrap">
            <button class="btn btn-info btn-sm" @click="detailsRow(props.rowData)">
              <i class="fa fa-search-plus"></i>
            </button>
            &nbsp;
            <button class="btn btn-info btn-sm" @click="historiqueRow(props.rowData)">
              <i class="fa fa-history"></i>
            </button>
            &nbsp;
          </div>
        </template>
        <template slot="details_and_history_and_pdf" slot-scope="props">
          <div class="table-button-container text-right text-nowrap">
            <button class="btn btn-info btn-sm" @click="detailsRow(props.rowData)">
              <i class="fa fa-search-plus"></i>
            </button>
            &nbsp;
            <button class="btn btn-info btn-sm" @click="historiqueRow(props.rowData)">
              <i class="fa fa-history"></i>
            </button>
            <!-- &nbsp;
            <button class="btn btn-info btn-sm" @click="cloneRow(props.rowData)">
              <i class="fa fa-clone"></i>
            </button> -->
            &nbsp;
            <button class="btn btn-info btn-sm" @click="pdfRow(props.rowData)">
              <i class="fa fa-file-pdf"></i>
            </button>
            &nbsp;
          </div>
        </template>
        <template slot="actions" slot-scope="props">
          <div class="table-button-container text-right text-nowrap">
            <button class="btn btn-warning btn-sm" @click="editRow(props.rowData)">
              <i class="fa fa-pencil-alt"></i> Edit
            </button>
            &nbsp;
            <button class="btn btn-danger btn-sm" @click="deleteRow(props.rowData)">
              <i class="fa fa-trash"></i> Delete
            </button>
            &nbsp;
          </div>
        </template>
      </vuetable>
      <!-- <vuetable-pagination-info ref="paginationInfo" info-template="{from}-{to}/{total} élements" no-data-template="Aucun élement"
      ></vuetable-pagination-info> -->
      <vuetable-pagination class="pull-right" ref="pagination"
      @vuetable-pagination:change-page="onChangePage"
      :css="mycss.pagination"></vuetable-pagination>
  </div>
</template>

<script>
import Vuetable from 'vuetable-2/src/components/Vuetable'
import VuetablePagination from '@/components/VuetablePaginationBootstrap4'
// import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
import CssConfig from './VuetableCssConfig.js'
import { secureGet } from '@/api/crm-api.js'

export default {
  components: {
    Vuetable,
    VuetablePagination,
    // VuetablePaginationInfo
  },
  props: {
    url: String,
    table: String,
    fields: Array,
    queryString: {
      type: String,
      default () {
        return ''
      }
    },
    sortOrder: 
    {
      type: Array,
      default () {
        return [
          {
            field: '1',
            direction: 'desc'
          }
        ]
      }
    },
    perPage: {
      type: Number,
      default() {
        return 15
      }
    },
    rowClass: Function
  },
  data () {
    return {
      mycss: CssConfig,
      currentPage: 1
    }
  },
  computed: {
  },
  methods: {
    refresh () {
      this.getDatas(this.currentPage)
    },
    getDatas (page = 1) {
      let url = "";
      if(this.url != null) {
        url = this.url+'?'
      } else {
        url = 'table?table='+this.table
      }
      url += '&page='+page+','+this.perPage+'&order='+this.sortOrder[0].field+','+this.sortOrder[0].direction+'&'+this.queryString

      secureGet(url)
        .then((response) => {
          var datas = response.data

          datas['pagination'] = {
              'total': parseInt(response.data.results),
              'per_page': this.perPage,
              'current_page': page,
              'last_page': Math.ceil(response.data.results / this.perPage),
              'from': 1,
              'to': this.perPage*page
          }

          this.$refs.vuetable.setData(datas)
          this.$refs.vuetable.changePage(page)
          this.currentPage = page
        })
        .catch((error) => {
          this.$store.commit('addMessage',{text:'Une erreur est survenue '+error.toString(), status:'danger'})
        })
    },
    onRowCLicked (rowData) {
      this.detailsRow(rowData)
    },
    historiqueRow (rowData) {
      this.$emit('historiqueRow',rowData)
    },
    detailsRow (rowData) {
      this.$emit('detailsRow',rowData)
    },
    editRow (rowData) {
      this.$emit('editRow',rowData)
    },
    cloneRow(rowData) {
      this.$emit('cloneRow',rowData)
    },
    pdfRow(rowData) {
      this.$emit('pdfRow',rowData)
    },
    deleteRow (rowData) {
      if(confirm('Etes vous sur de vouloir supprimer cette ligne ?')) {
        this.$emit('deleteRow',rowData)
      }
    },
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
    },
    onChangePage (page) {
      if (page == 'next') page = this.currentPage + 1
      if (page == 'prev') page = this.currentPage - 1
      this.addParamsToLocation({page: page})
      this.getDatas(page)
    },
    handleLoadError(payload) {
      if(payload.response.status === 401) {
        this.$router.replace({name:'401'}).catch(() => {})
      }
    },
    addParamsToLocation(params) {
      history.pushState(
        {},
        null,
        this.$route.path +
          '?' +
          Object.keys(params)
            .map(key => {
              return (
                encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
              )
            })
            .join('&')
      )
    }
  },
  mounted () {
    if(this.$route.query.page) {
      this.currentPage = parseInt(this.$route.query.page)
    }
    this.refresh()
  },
  watch: {
    sortOrder: {
      handler: function () { 
        this.refresh() 
      },
      deep: true
    },
    queryString: function () {
      this.refresh() 
    },
    url: function () {
      this.refresh() 
    }
  }
}
</script>

<style>
table.vuetable tr{
  cursor:pointer;
}
</style>
